<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>

export default {
  name: 'App',
  computed: {
    key() {
      return this.$route.path
    },
  }
}
</script>
<style>
@charset "utf-8";

body {
  font-size: 16px;
  background-color: #f8f8f8 !important;
  -webkit-font-smoothing: antialiased;
}

#app {
  height: 100vh;
  width: 100%;
}

/* CSS Document */
a,
img,
button,
input,
textarea,
div,
p {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

* {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

html,
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
button,
dl,
dd,
dt {
  margin: 0;
  padding: 0;
  font-size: 100%;
}

img {
  width: 100%;
  border: 0;
  display: block;
  height: auto;
  vertical-align: top;
}

body {
  font-family: PingFangSC-Regular, '微软雅黑', 'Hiragino Sans GB', 'Helvetica Neue';
  color: #333;
  background: #fff;
}

ul,
ol,
dl,
dd,
dt {
  list-style: none;
  margin: 0;
  padding: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
}

a,
img,
button,
input,
textarea {
  outline: none;
  border: none;
  background: none;
  -webkit-appearance: none;
}

a {
  color: #333;
  text-decoration: none;
}

input[type='button'],
input[type='search'],
input[type='text'],
input[type='number'] {
  font-family: PingFangSC-Regular, '微软雅黑', 'Hiragino Sans GB', 'Helvetica Neue';
  -webkit-appearance: none;
  outline: none;
}

.clearfix:after {
  clear: both;
  display: block;
  visibility: hidden;
  height: 0;
  content: '.';
}

.clearfix {
  zoom: 1;
}

.clear {
  clear: both;
  display: block;
  overflow: hidden;
  height: 0;
  font-size: 0;
}

i {
  font-style: normal;
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 121;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  line-height: 100vh;
}
.van-checkbox__icon .van-icon {
  border-radius: 4px;
}
.van-icon .van-icon-close {
  color: #c4c0c0;
}
</style>